<template>
  <div class="permission-denied-page">
    <div class="content-wrapper">
      <div class="icon-wrapper">
        <img src="/img/403.svg" alt="403 Forbidden" class="error-image" width="332"/>
      </div>

      <h1 class="title">Access Restricted</h1>
      <p class="description">You don't have permission to access this resource.</p>

      <div class="steps">
        <p class="steps-title">To get access:</p>
        <ol class="steps-list">
          <li>Contact your system administrator</li>
          <li>Request permission for this module</li>
          <li>Refresh after permission is granted</li>
        </ol>
      </div>

      <button @click="goBackToDashboard" class="btn-back">
        Back to Dashboard
      </button>
    </div>
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'

export default {
  name: 'PermissionDenied',
  setup() {
    const router = useRouter()
    const route = useRoute()

    const goBackToDashboard = () => {
      const isMemberRoute = route.path.startsWith('/client/')
      
      if (isMemberRoute) {
        router.push('/client/dashboard')
      } else {
        router.push({ name: 'Home' })
      }
    }

    return {
      goBackToDashboard
    }
  }
}
</script>

<style scoped>
.permission-denied-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: #fafafa;
}

.content-wrapper {
  max-width: 480px;
  width: 100%;
  text-align: center;
}

.icon-wrapper {
  margin-bottom: 32px;
}

.error-image {
  width: 332px;
  height: auto;
  max-width: 100%;
}

.title {
  font-size: 28px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 12px 0;
  letter-spacing: -0.02em;
}

.description {
  font-size: 16px;
  color: #6b7280;
  margin: 0 0 40px 0;
  line-height: 1.5;
}

.steps {
  text-align: left;
  margin-bottom: 40px;
  background-color: #f9fafb;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.steps-title {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 16px 0;
}

.steps-list {
  margin: 0;
  padding-left: 24px;
  list-style: decimal;
}

.steps-list li {
  font-size: 14px;
  color: #4b5563;
  line-height: 1.7;
  margin-bottom: 10px;
  padding-left: 8px;
}

.steps-list li:last-child {
  margin-bottom: 0;
}

.btn-back {
  width: 100%;
  padding: 12px 24px;
  font-size: 15px;
  font-weight: 500;
  color: #ffffff;
  background-color: var(--primary-color, #007bff);
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: filter 0.3s ease;
}

.btn-back:hover {
  filter: brightness(0.9);
}

.btn-back:active {
  filter: brightness(0.8);
}

@media (max-width: 640px) {
  .permission-denied-page {
    padding: 24px 16px;
  }

  .icon-wrapper {
    margin-bottom: 24px;
  }

  .error-image {
    width: 160px;
  }

  .title {
    font-size: 24px;
    margin-bottom: 8px;
  }

  .description {
    font-size: 15px;
    margin-bottom: 32px;
  }

  .steps {
    margin-bottom: 32px;
    padding: 20px;
  }

  .steps-title {
    font-size: 13px;
    margin-bottom: 12px;
  }

  .steps-list {
    padding-left: 20px;
  }

  .steps-list li {
    font-size: 13px;
    margin-bottom: 8px;
    padding-left: 6px;
  }

  .btn-back {
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>
